// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
import Tooltip from './Tooltip';
const DEFAULT_TEXT = {
  active: 'ACTIVE',
  warning: 'WARNING',
  error: 'ERROR',
  default: 'DEFAULT',
  info: 'INFO',
  archived: 'ARCHIVED',
  draft: 'DRAFT',
  scheduled: 'SCHEDULED',
};
type Props = {
  type: 'active' | 'warning' | 'error' | 'default' | 'info' | 'archived' | 'draft' | 'scheduled';
  text?: string;
  className?: string;
  textClassName?: string;
  boldTextClassName?: string;
  tooltipBody?: string | React.ReactElement<any>;
  interactive?: boolean;
};

/**
 * @deprecated
 *
 * Instead use the "Label" component from '@branchjs/neo-components';
 */
class StatusLabel extends React.PureComponent<Props> {
  static defaultProps = {
    interactive: false,
  };

  _renderLabelText = () => {
    const { tooltipBody, type, interactive, textClassName, boldTextClassName } = this.props;
    // This allows devs to render an empty status label
    const text = this.props.text === '' || this.props.text ? this.props.text : DEFAULT_TEXT[type];

    if (!tooltipBody) {
      return (
        <div
          className={classNames(
            'status-label__superimposed-background',
            'status-label__text-container',
            textClassName,
            boldTextClassName
          )}
        >
          {text}
        </div>
      );
    }

    return (
      <Tooltip
        body={tooltipBody}
        className="status-label__superimposed-background status-label__text-container"
        interactive={interactive}
        data-testid="fraud-rule-display__blocked"
      >
        {text}
      </Tooltip>
    );
  };

  render() {
    const { type, className } = this.props;
    const statusTypeClassName = `status-label__${type}`;
    return (
      <div data-testid="status-label" className={classNames('status-label', statusTypeClassName, className)}>
        {this._renderLabelText()}
      </div>
    );
  }
}

export default StatusLabel;
